import { bind } from 'decko'
import LiveNodeList from 'live-node-list'

export default class InteractiveMap {
  triggers = new LiveNodeList('.interactive-map__trigger')

  closeButtons = new LiveNodeList('.interactive-map-block__close-button')

  constructor() {
    this.registerListeners()
  }

  registerListeners() {
    this.triggers.addEventListener('click', this.togglePopup)
    this.closeButtons.addEventListener('click', this.closePopup)
  }

  togglePopup(event) {
    const trigger = event.currentTarget
    const popupId = trigger.getAttribute('aria-controls')
    const popup = document.getElementById(popupId)
    const triggers = document.querySelectorAll(`[aria-controls="${popupId}"]`)

    const isHidden = popup.getAttribute('aria-hidden') === 'true'

    popup.setAttribute('aria-hidden', isHidden ? 'false' : 'true')
    triggers.forEach(trigger =>
      trigger.setAttribute('aria-expanded', isHidden ? 'true' : 'false'),
    )
  }

  closePopup(event) {
    const trigger = event.currentTarget
    const popupId = trigger.getAttribute('aria-controls')
    const popup = document.getElementById(popupId)
    const triggers = document.querySelectorAll(`[aria-controls="${popupId}"]`)

    popup.setAttribute('aria-hidden', 'true')
    triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'))
  }
}
